import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BusinessManagementFormService } from './shared/business-management-form.service';
import { BusinessManagementDataService } from './shared/business-management-data.service';
import { BaseControl, ConfirmComponent, EmpresaPredeterminada, Const } from '@app/shared';
import { ManagementSystemDataService } from '../shared/management-system-data.service';
import { AuthenticationService } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-business-management',
  templateUrl: './business-management.component.html',
  styleUrls: ['./business-management.component.scss'],
  providers: [
    BusinessManagementFormService,
    BusinessManagementDataService,
    ManagementSystemDataService
  ]
})
export class BusinessManagementComponent implements OnInit, OnDestroy {
  // Pregunta de la modal de confirmaciones
  question = '';
  // Contiene el id de la empresa del usuario logueado
  empresaSelect: number;
  // los datos de la empresa
  data: any;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    update: false
  };
  // Controles del formulario
  controls: BaseControl<any>[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia de la modal de confirmaciones
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private bmfs: BusinessManagementFormService,
    private bmds: BusinessManagementDataService,
    private msds: ManagementSystemDataService,
    private toastr: ToastrService,
    private as: AuthenticationService) { }

  ngOnInit() {
    // determina los permisos del usuario en sesion
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationSystem,
      Const.types_action_permissions.updateCompany
    );
    this.idSelectCompany();
    this.companyData();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Obteniendo id empresa de usuario logueado
   *
   * @memberof BusinessManagementComponent
   */
  idSelectCompany() {
    this.empresaSelect = this.msds.idSelectCompany();
  }

  /**
   * Obteniendo datos de la empresa según id
   *
   * @memberof BusinessManagementComponent
   */
  companyData() {
    this.bmds.getCompany(this.empresaSelect).subscribe((empresa) => {
      // Asignando los datos en los campos del formulario
      this.controls = this.bmfs.getFormEmpresa(empresa);
    });
  }

  /**
   * Edita la empresa en el sistema
   *
   * @param {*} data
   * @memberof BusinessManagementComponent
   */
  sended(data: any) {
    if (data) {
      let empresa: EmpresaPredeterminada = new EmpresaPredeterminada();
      empresa = {
        nombre: data.nombre,
        descripcion: data.descripcion,
        web_page: data.web_page,
        logo: data.logo,
        dias_laborales: [],
        mensaje: data.mensaje
      };

      if (data.lunes) {
        empresa.dias_laborales.push(0);
      }
      if (data.martes) {
        empresa.dias_laborales.push(1);
      }
      if (data.miercoles) {
        empresa.dias_laborales.push(2);
      }
      if (data.jueves) {
        empresa.dias_laborales.push(3);
      }
      if (data.viernes) {
        empresa.dias_laborales.push(4);
      }
      if (data.sabado) {
        empresa.dias_laborales.push(5);
      }
      if (data.domingo) {
        empresa.dias_laborales.push(6);
      }

      if (this.activateAction.update) {
        if (this.empresaSelect) {
          this.bmds.updateCompany(this.empresaSelect, empresa).then(() => {
          });
        }
      } else {
        this.toastr.error('Usted no posee permisos para modificar la empresa', 'Permiso denegado');
      }
    }
  }

  /**
   * Activa modal de confirmación
   *
   * @param {any} data
   * @memberof BusinessManagementComponent
   */
  openModalConfirm(data: any) {
    this.question = '¿Realmente desea editar la empresa?';
    this.confirm.open();
    this.data = data;
  }

  /**
   * Recibe respuesta del modal de confirmación
   *
   * @param {boolean} res
   * @memberof BusinessManagementComponent
   */
  actionComfirm(res: boolean) {
  if (res) {
    this.sended(this.data);
  }
  this.question = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/business-management/business-management.component.ts